// extracted by mini-css-extract-plugin
module.exports = {"ownerInfo":"styles_ownerInfo__6ud4f","withCollaborators":"styles_withCollaborators__1uNOV","role":"styles_role__28YH1"};